import random from 'lodash/random';
import { SvgUri } from 'react-native-svg';

import { Button } from '@oui/app-core/src/components/Button';
import { Heading, Label, Text } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';
import { useTheme } from '@oui/app-core/src/styles';

/**
 * An interstitial UI between rounds.
 */
export const StressBreathingBreak = ({
  round,
  onStart,
}: {
  round: number;
  onStart: () => unknown;
}) => {
  const { theme } = useTheme();
  return (
    <View testID="StressBreathingBreak" style={{ gap: 50 }}>
      <View style={{ gap: 15 }}>
        <Heading level={2} text="Break" textAlign="center" color="white" />
        <Label
          text="Take a 1 to 2-minute break before starting the next round."
          textAlign="center"
          color="white"
        />
      </View>
      <Text
        text="You can observe the room around you or look at the picture below."
        textAlign="center"
        color="white"
      />
      <View
        style={{
          backgroundColor: 'white',
          borderRadius: 10,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SvgUri
          // @ts-ignore broken in top-level type-check --watch https://github.com/expo/expo/pull/34112
          uri={`https://storage.googleapis.com/asset.oui.dev/static/stress-breathing-break-svgs/Scribble-${process.env.STORYBOOK_CLIENT ? 1 : random(1, 50, false)}.svg`}
          color={theme.color.primary200}
        />
      </View>
      <View style={{ gap: 25 }}>
        <Label text="When ready, begin the next round. " textAlign="center" color="white" />
        <Button
          // +1 for 0 index -> 1 index
          // +1 for next round
          text={`Start round ${round + 1 + 1}`}
          onPress={onStart}
          variant="solid"
          _accentColor="white"
        />
      </View>
    </View>
  );
};
